import { useState, type FC } from "react";
import { TabbedPanel } from "@uhg-harmony/react";
import { StyledTabbedPanelContent } from "../../styles/styles";
import { TabContent } from "../common/TabContent";
import type { ApiTemplateFolder } from "../../../../redux/templates/templatesTypes";
import "../../styles/library.css";

interface ApiFolderTabbedPanelProps {
  folderGroups: ApiTemplateFolder[];
  numberOfColumns?: number;
  onLoadTemplate?: (html: string) => void;
  emptyMessage?: string;
}

export const ApiFolderTabbedPanel: FC<ApiFolderTabbedPanelProps> = ({
  folderGroups,
  numberOfColumns = 3,
  onLoadTemplate,
  emptyMessage = "No templates available.",
}) => {
  const [currentPanel, setCurrentPanel] = useState(0);

  if (!folderGroups || folderGroups.length === 0) {
    return (
      <div className="template-empty-message">
        {emptyMessage}
      </div>
    );
  }

  const tabPanels = folderGroups.map((folder) => {
    const rows: typeof folder.templates[] = [];
    for (let i = 0; i < folder.templates.length; i += numberOfColumns) {
      rows.push(folder.templates.slice(i, i + numberOfColumns));
    }

    return {
      header: folder.folderName,
      content: (
        <>
          {rows.length === 0 ? (
            <div className="template-empty-message">
              No templates in this folder.
            </div>
          ) : (
            rows.map((row, rIdx) => (
              <div className="row noborder" key={row[0]?.templateId ?? rIdx}>
                {row.map((template, cIdx) => (
                  <TabContent
                    key={template.templateId ?? cIdx}
                    templateId={template.templateId}
                    heading={template.templateName}
                    description={null}
                    src={
                      template.versions
                        ?.slice()
                        .sort((a, b) => (b.templateVersionNumber ?? 0) - (a.templateVersionNumber ?? 0))
                        ?.[0]?.s3Path
                    }
                    onLoadTemplate={onLoadTemplate}
                  />
                ))}
              </div>
            ))
          )}
        </>
      ),
    };
  });

  return (
    <StyledTabbedPanelContent>
      <TabbedPanel
        panels={tabPanels}
        onHeaderPress={setCurrentPanel}
        selectedPanel={currentPanel}
      />
    </StyledTabbedPanelContent>
  );
};
